import { h } from 'preact';
import { useEffect, useMemo, useState } from 'preact/hooks';
import { useStyles } from '../../../common/hooks';
import { connect } from '../../hoc';
import '../../theme/styles/subtitles.css';
import { subtitlePositionAndSize } from '../../utils/tools';
import { SUBTITLE_CONTAINER_STYLE, SUBTITLE_LINE_STYLE } from './styles';

function SubtitleContainer({
  width,
  height,
  tags,
  active,
  alignment,
  position,
  style = {},
  sideMargin = 0,
  fontFamily, fontRatio = 1,
  UIVisible,
  isTv,
  isPortrait
}) {
  const tagStyles = useMemo(
    () => ({
      ...SUBTITLE_LINE_STYLE,
      fontFamily,
      fontSize: `${1 * fontRatio}em`
    }),
    [fontRatio, fontFamily]
  );

  const tvTop = useMemo(
    () => (isTv
      ? {
        default: { top: 48 },
        'extraLargeTv+extraLarge': { top: 63 }
      }
      : {
        default: { top: isPortrait ? 85 : 75 },
        extraSmall: { top: 68.5 },
        medium: { top: isPortrait ? 90 : 69 },
        extraLarge: { top: 83 }
      }),
    [isTv, isPortrait]
  );
  const { top } = useStyles()(tvTop);

  const [transition, setTransition] = useState('none');
  useEffect(() => {
    const transitionDelay = 200;
    if (UIVisible) {
      setTransition(UIVisible ? `all cubic-bezier(0.16, 1, 0.99, 0.99) ${transitionDelay / 1000}s` : '');
    } else {
      setTimeout(() => setTransition('none'), transitionDelay);
    }
  }, [UIVisible]);

  const wrapperStyle = useMemo(
    () => {
      const getParams = (() => {
        if (!UIVisible) {
          return { width, height, position, alignment, fontRatio };
        }

        return {
          position: {
            top,
            left: 50
          },
          alignment: {
            horizontal: 'center',
            vertical: 'center'
          },
          fontRatio,
          width,
          height
        };
      });
      return ({
        ...SUBTITLE_CONTAINER_STYLE,
        ...subtitlePositionAndSize(getParams(), sideMargin),
        transition
      });
    },
    [width, height, alignment, position, fontRatio, sideMargin, UIVisible, top, transition]
  );

  return active ? (
    <div style={style} className="ftv-magneto--wrapper-subtitles">
      <div
        className="ftv-magneto--subtitles"
        style={wrapperStyle}
      >
        {tags.map(({ tagName, text, cssClasses }) => {
          const Tag = tagName;
          return <Tag className={cssClasses?.join(' ') || ''} style={tagStyles}>{text}</Tag>;
        })}
      </div>
    </div>
  ) : null;
}

export default connect(({
  subtitles: { settings: { fontFamily, fontRatio } },
  media: { isTv },
  ui: { UIVisible, isPortrait }
}) => ({
  fontFamily, fontRatio,
  UIVisible, isTv, isPortrait
}))(SubtitleContainer);
